import {
  CardType,
  SPONSORED_ADVERT_CARD_TYPE,
  SPONSORED_ADVERT_STATUS,
  SponsoredAdvertStatus,
} from 'models/SponsoredAdvert';

export const STATUS_COPY_MAP: Record<string, string> = {
  UPDATED_EXISTING_AD: 'udatedSposoredAd',
  PUBLISHED_NEW_AD: 'publishedSposoredAd',
  UPDATED_DRAFT: 'udatedSposoredDraftAd',
};

export const getIsAdStatusDrafted = (status: SponsoredAdvertStatus) =>
  status === SPONSORED_ADVERT_STATUS.DRAFTED;

export const getIsAdStatusPaused = (status: SponsoredAdvertStatus) =>
  status === SPONSORED_ADVERT_STATUS.PAUSED;

export const getIsAdTypeMedRec = (type: CardType) =>
  type === SPONSORED_ADVERT_CARD_TYPE.MED_REC;
